import { useTheme } from "@mui/material";
import { valueOrEmpty } from "./tools";

const SimpleDisplayField = (props: { value: any; fontSize?: number | string }) => (
    <div
        style={{
            fontSize: props.fontSize || useTheme().typography.body1.fontSize,
            padding: "4px 0",
            marginBottom: 2,
        }}
    >
        {valueOrEmpty(props.value)}
    </div>
);

export default SimpleDisplayField;
